import React, { Component, Fragment } from 'react';
import MaterialTableComponent from '../../../src/utils/MaterialTable';
import atErrorCodes from '../../../src/data/at_error_codes';
import spritesheet from '../../icons/spritesheet-simbologia.png';
import style from './style';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';

import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import Footer from '../../layouts/Dashboard/components/Footer/index';
import Typography from '@material-ui/core/Typography';

class Symbology extends Component {
  constructor(props) {
    super(props);
    var searchText = "Búsqueda"
    this.state = {
      keys: [{"title":"Nombre","field":"nombre", "headerStyle": {"paddingLeft": "50px", "fontSize": "16px"}, "cellStyle": {"fontFamily": "Roboto", "fontWeight": "bold","fontSize": "14px", "paddingLeft": "50px"}},
      {"title":"Código", "field":"id", "headerStyle": {"fontSize": "16px"}, "cellStyle": {"fontSize": "14px", "fontFamily": "Roboto", "fontWeight": "bold"}},
      { "title": "Ícono", "field": "posicion", "headerStyle": {"fontSize": "16px"}, "cellStyle": {"fontSize": "14px", "fontFamily": "Roboto"}},
      {"title":"Descripción","field":"descripcion", "headerStyle": {"fontSize": "16px"}, "cellStyle": {"fontSize": "14px", "fontFamily": "Roboto"}},
      {"title":"Servicio","field":"servicio", "headerStyle": {"fontSize": "16px"}, "cellStyle": {"fontSize": "14px", "fontFamily": "Roboto"}},
      ],
      rows: atErrorCodes
    }
  }

  componentWillMount(){
    this.addIcon()
  }

  addIcon=()=>{
    var rowsNew=[]
    this.state.rows.map(ele=>{
      var codeIcon = <i style={{backgroundImage: `url(${ spritesheet })`, backgroundRepeat: 'no-repeat', display: 'block', width: '286px', height: '252px', backgroundPosition: ele.posicion, zoom: '30%', scale:"0.3", transform:'scale(0.8)'}}></i>
      
      ele["posicion"]=codeIcon
      
      rowsNew.push(ele)
    })
    rowsNew.push({cellStyle: {backgroundColor: '#000',color: 'red'},headerStyle: {backgroundColor: '#039be5',}})
    this.setState({
      rows:rowsNew
    })
  }

	render() {
    const { keys, rows } = this.state
    return (
      <Portlet style={{backgroundColor:"#39424c"}}>
        <PortletHeader>
        <Typography
            style={{fontWeight: 500, fontFamily: 'Roboto', color: "white"}}
            variant="h3"
          >
            Simbología
          </Typography>
          <a href="https://reporte.atentus.com">
            <img
              alt="Atentus logo"
              src="/images/logos/logo-atentus-gris.svg"
              height="40px"
            />
          </a>
        </PortletHeader>
        <MaterialTableComponent
          rowsForPage={rows.length} 
          changeTittle={""}
          colorSearch={'#FF8B32'}
          keys={keys} 
          data={rows}
          //searchText={searchText}
          paging={false}
          grouping={false}
          />          
        <Footer marginTop={'0px'}/>
      </Portlet>
    );
  }
}

export default compose( withStyles(style)) (Symbology);